import {IHtmlTemplate} from 'Admin/AdminSettings/models/IHtmlTemplate';
import {convertUTCToClientDate} from 'Common/helpers/DateHelper';

export function convertHtmlTemplateToClient(template: IHtmlTemplate): IHtmlTemplate {
  return {...template, updatedDate: convertUTCToClientDate(template.updatedDate) || ''};
}
